import React from 'react';
import { IconProps } from '.';

const SvgColoredMoneyFly = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <rect
        width={19.2}
        height={12}
        x={1.447}
        y={15.074}
        fill='#5AC27C'
        rx={1.8}
        transform='rotate(-45 1.447 15.074)'
      />
      <path fill='#F2AB6D' d='m5.69 10.831 3.394-3.394 8.485 8.485-3.394 3.395z' />
      <rect width={19.2} height={12} x={0.6} y={14.225} fill='#91D6A7' rx={1.8} transform='rotate(-45 .6 14.225)' />
      <path fill='#5AC27C' d='M15.872 12.527a3.6 3.6 0 1 0-5.091-5.09 3.6 3.6 0 0 0 5.091 5.09Z' />
      <path fill='#F8D5B6' d='m4.841 9.983 3.394-3.394 8.485 8.485-3.394 3.394z' />
      <path
        fill='#ECEDEE'
        d='m22.237 21.91.018-.014c.046-.045.081-.097.121-.147.028-.035.06-.068.085-.103.024-.034.043-.068.064-.102.947-1.458.327-3.93-1.547-5.804-1.875-1.875-4.347-2.495-5.805-1.548-.034.021-.068.04-.102.064-.035.026-.069.058-.102.085-.05.04-.102.075-.148.121-.006.006-.01.013-.014.02-.008.006-.016.011-.024.02l.004.002c-.667.708-.675 1.804-.004 2.475.672.672 1.766.663 2.475-.004l.007.008c-.014.013-.029.022-.042.035-.706.706-.723 1.832-.04 2.517.684.683 1.812.667 2.517-.04.013-.013.022-.028.035-.042l.008.008c-.667.708-.676 1.803-.004 2.475.672.671 1.766.663 2.474-.004l.004.004c.007-.009.012-.018.02-.026ZM9.902 8.517l.019-.015c.046-.045.081-.097.12-.147.028-.034.06-.067.085-.103.024-.033.043-.067.065-.101.946-1.458.326-3.931-1.548-5.805C6.768.47 4.296-.15 2.838.797c-.034.022-.069.04-.102.065-.036.026-.069.057-.103.085-.05.04-.102.074-.147.12l-.015.019-.024.02.004.003c-.667.708-.675 1.804-.004 2.475.672.671 1.767.663 2.475-.003l.007.007c-.014.013-.029.022-.042.035-.706.706-.723 1.832-.039 2.517.684.685 1.81.667 2.517-.039.013-.013.022-.028.035-.042l.007.007c-.666.708-.675 1.803-.003 2.475.671.67 1.766.663 2.474-.004l.003.004.021-.024Z'
      />
    </svg>
  );
};

export default SvgColoredMoneyFly;
